module.exports = __webpack_public_path__ + "img/sanalsantral-logo.4f3d0823.svg";